"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _withScopeId = (n) => ((0, vue_2.pushScopeId)("data-v-a8d98b6c"), n = n(), (0, vue_2.popScopeId)(), n);
const _hoisted_1 = ["value"];
const _hoisted_2 = ["value"];
const _hoisted_3 = ["value"];
const _hoisted_4 = { class: "delete-btn-cell" };
const _hoisted_5 = { class: "svg-container delete-icon-container oplus-icon" };
const vue_3 = require("vue");
const DeleteIcon_vue_1 = __importDefault(require("../../vue/icons/DeleteIcon.vue"));
const common_1 = require("../../common/common");
var InputType;
(function (InputType) {
    InputType["startTime"] = "startTime";
    InputType["endTime"] = "endTime";
    InputType["requiredCount"] = "requiredCount";
})(InputType || (InputType = {}));
exports.default = (0, vue_1.defineComponent)({
    __name: 'SectionTemplateModalRow',
    props: {
        requiredTimeSlot: {
            type: Object,
            required: true,
        },
        index: {
            type: Number,
            required: true,
        },
    },
    emits: ["emit-template-timeframe", "emit-template-remove"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emits = __emit;
        const startTime = (0, vue_3.computed)(() => {
            if (!props.requiredTimeSlot?.startTime) {
                return "";
            }
            return props.requiredTimeSlot.startTime;
        });
        const endTime = (0, vue_3.computed)(() => {
            if (!props.requiredTimeSlot?.endTime) {
                return "";
            }
            return props.requiredTimeSlot.endTime;
        });
        const reqCount = (0, vue_3.computed)(() => {
            return props.requiredTimeSlot.requiredCount;
        });
        function constructAndEmitTimeframeData(event, fieldType) {
            const target = event.target;
            const rawValue = (0, common_1.fullWidthToAscii)(target.value);
            const value = fieldType === InputType.requiredCount ? rawValue : (0, common_1.extractTimeAndMin)(rawValue, false).toString();
            const emitData = {
                index: props.index,
                startTime: fieldType === InputType.startTime ? value : props.requiredTimeSlot.startTime,
                endTime: fieldType === InputType.endTime ? value : props.requiredTimeSlot.endTime,
                requiredCount: fieldType === InputType.requiredCount ? value : props.requiredTimeSlot.requiredCount,
            };
            emits("emit-template-timeframe", emitData);
        }
        function handleStartChange(event) {
            constructAndEmitTimeframeData(event, InputType.startTime);
        }
        function handleEndChange(event) {
            constructAndEmitTimeframeData(event, InputType.endTime);
        }
        function handleCountChange(event) {
            constructAndEmitTimeframeData(event, InputType.requiredCount);
        }
        function handleTemplateRemove() {
            const emitData = {
                index: props.index,
                startTime: '',
                endTime: '',
                requiredCount: ''
            };
            emits("emit-template-remove", emitData);
        }
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("tr", null, [
                (0, vue_2.createElementVNode)("td", null, [
                    (0, vue_2.createElementVNode)("input", {
                        value: startTime.value,
                        onChange: _cache[0] || (_cache[0] = ($event) => (handleStartChange($event))),
                        class: "sect-template-input text-center",
                        type: "text",
                        placeholder: "9:00"
                    }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_1)
                ]),
                (0, vue_2.createElementVNode)("td", null, [
                    (0, vue_2.createElementVNode)("input", {
                        value: endTime.value,
                        onChange: _cache[1] || (_cache[1] = ($event) => (handleEndChange($event))),
                        class: "sect-template-input text-center",
                        type: "text",
                        placeholder: "10:00"
                    }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_2)
                ]),
                (0, vue_2.createElementVNode)("td", null, [
                    (0, vue_2.createElementVNode)("input", {
                        value: reqCount.value,
                        onChange: _cache[2] || (_cache[2] = ($event) => (handleCountChange($event))),
                        class: "sect-template-input text-center",
                        type: "text",
                        placeholder: "4"
                    }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_3)
                ]),
                (0, vue_2.createElementVNode)("td", _hoisted_4, [
                    (0, vue_2.createElementVNode)("button", {
                        class: "role-template-delete-btn c-hand text-error",
                        onClick: handleTemplateRemove
                    }, [
                        (0, vue_2.createElementVNode)("div", _hoisted_5, [
                            (0, vue_2.createVNode)(DeleteIcon_vue_1.default)
                        ])
                    ])
                ])
            ]));
        };
    }
});
